module.exports = __webpack_public_path__ + "static/media/snow.9a2025df.svg";